export const ON_ERROR = 'on-error'
export const ON_SUCCESS = 'on-success'
export const ON_CANCEL = 'on-cancel'
export const ON_ATTEMPT = 'on-attempt'
